import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useKeycloak } from "@react-keycloak/web";
import Swal from "sweetalert2";
import EditProjectTemplate from "../../Templates/EditProject";
import companyService from "../../../services/Companies/CompanyService";
import projectService from "../../../services/Projects/ProjectService";

export default function EditProject() {
    const { keycloak, initialized } = useKeycloak();
    const [currentProject, setCurrentProject] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    
    useEffect(() => {
        setLoading(true);
        loadAllCompanies();
        loadProject();
        setLoading(false);
    }, [initialized, keycloak.id, id])

    const loadAllCompanies = async () => {
        try {
            const allCompanies = await companyService.getAllCompanies(keycloak.token);
            setCompanies(allCompanies);
        } catch (error) {
            console.error("Error to get all companies", error);
        }
    }

    const loadProject = async () => {
        try {
            const project = await projectService.getProjectById(id, keycloak.token);
            setCurrentProject(project);
        } catch (error) {
            console.error("Error to get project", error);
            Swal.fire({
                icon: "error",
                position: "top-end",
                title: "Erro ao carregar projeto",
                showConfirmButton: false,
                timer: 1800,
                background: '#27272A',
                color: '#fff',
              });
        }
    }

    return (
        <EditProjectTemplate
            project={currentProject}
            companies={companies}
            loading={loading}
            keycloak={keycloak}
        />
    )
}